import { render, staticRenderFns } from "./stations.vue?vue&type=template&id=32b36128&scoped=true&"
import script from "./stations.vue?vue&type=script&lang=js&"
export * from "./stations.vue?vue&type=script&lang=js&"
import style0 from "./stations.vue?vue&type=style&index=0&id=32b36128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b36128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDataTable,VForm})
